module.exports = __webpack_public_path__ + "img/Noctiluca-Process-6-mobile.c25fa5e7.png";